// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep.profile_types {
  background-image: url("https://assets.foursightonline.com/app/images/foursight-profile-types.svg") !important;
  background-color: transparent;
  background-repeat: no-repeat;
  width: 34px;
  height: 15px;
  margin-left: 6px;
}

::ng-deep #holder > li {
  padding: 5px;
  margin: 2px;
  display: inline-block;
}

::ng-deep #holder > li[data-page] {
  border: solid #a0a0a0 1px;
  border-radius: 5px;
}

::ng-deep #holder > li.separator:before {
  content: "...";
}

::ng-deep #holder > li.active {
  background-color: darkblue;
  color: #fff;
}

::ng-deep #holder > li[data-page]:hover {
  cursor: pointer;
}

::ng-deep .no-profile {
  background-image: url("https://assets.foursightonline.com/app/images/foursight-profile-types.svg") !important;
}

::ng-deep .checkbox {
  padding-left: 20px;
}
::ng-deep .pull-right {
  float: right !important;
}
::ng-deep .ibox-title.profile-heading-2 h5 {
  width: 100%;
  vertical-align: top;
}
::ng-deep .ibox-title.profile-heading-2 h5 ul.inline-list {
  padding: 0;
}
::ng-deep table.profile-layout.table-striped tr {
  background: #f1f1f2;
  border-left: 1px solid #d0d0d0;
  border-right: 1px solid #d0d0d0;
}
::ng-deep table.profile-layout.table-striped tr td {
  vertical-align: middle;
}
::ng-deep table.profile-layout.table-striped tr th {
  vertical-align: middle;
}
::ng-deep table.profile-layout.table-striped tr th span.sortby {
  width: 100%;
  height: 100%;
  text-align: right;
  display: block;
  position: absolute;
  right: 0;
  top: 14px;
  cursor: pointer;
  font-size: 16px;
}
::ng-deep table.profile-layout.table-striped tr th span.sortby.fname-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.lname-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.email-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.org-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.team-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.profile-asc {
  top: 8px !important;
}
::ng-deep table.profile-layout.table-striped tr input {
  border: 1px solid #ccc;
  padding: 6px 10px;
  height: 34px;
  line-height: 1;
}
::ng-deep table.profile-layout.table-striped tr input[type=checkbox] {
  height: auto !important;
}
::ng-deep table.profile-layout.table-striped tr select {
  border: 1px solid #ccc;
  padding: 6px 12px;
  height: 34px;
  min-width: 100px;
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 14px;
}
::ng-deep table.profile-layout.table-striped tr:nth-child(odd) {
  background: #fff;
}
::ng-deep table.profile-layout.table-striped tr a {
  color: #333;
}
::ng-deep table.profile-layout.table-striped tr a:hover {
  color: #337ab7;
}
::ng-deep table.profile-layout.table-striped tr a.label.label-default {
  background: #d1dade;
  border-radius: 2.5px;
}
::ng-deep table.profile-layout.table-striped tr a.label.label-default:hover {
  background-color: #5e5e5e;
}
::ng-deep table.profile-layout.table-striped tr:first-child th {
  background: #464646;
  color: #fff;
  padding: 10px 10px 5px 10px;
  white-space: nowrap;
}
::ng-deep table.profile-layout.table-striped tfoot tr {
  border: none !important;
}
::ng-deep ::ng-deep #holder li {
  border: 1px solid #ccc !important;
  border-radius: 0 !important;
  padding: 7px 11px;
}
::ng-deep ::ng-deep #holder li.active {
  background: #464646;
}
::ng-deep table.profile-layout.table-striped tr input[type=date]::-webkit-inner-spin-button,
::ng-deep table.profile-layout.table-striped tr input[type=date]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
::ng-deep span.invitation-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 160px !important;
  overflow: hidden;
  display: block;
}
::ng-deep span.contact-lists {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px !important;
  overflow: hidden;
  display: block;
}
::ng-deep a.orgs-lists {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80px !important;
  overflow: hidden;
  display: block;
}
::ng-deep .selectDataChild {
  width: 100%;
}
::ng-deep .selectDataChild tr:nth-child(odd) {
  background: #f1f1f2;
}
::ng-deep .selectDataChild th,
::ng-deep .selectDataChild td {
  padding: 5px 10px;
}
::ng-deep .selectDataChild th:last-child,
::ng-deep .selectDataChild td:last-child {
  text-align: center;
}
::ng-deep .reset-input th {
  position: relative;
}
::ng-deep .reset-input th input[type=search] {
  width: 100% !important;
}
::ng-deep .reset-input th .reset-close {
  display: none;
  position: absolute;
  top: 0;
  right: 25px;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #ddd;
  border: none !important;
  text-align: center;
  font-size: 14px;
  padding: 0px !important;
  height: 16px !important;
  width: 16px !important;
  color: #fff;
  line-height: 1.2 !important;
  font-family: Arial !important;
  transform: rotate(45deg) !important;
  -webkit-transform: rotate(45deg) !important;
}
::ng-deep .reset-input th:hover .reset-close {
  display: block;
}
::ng-deep #templates {
  width: auto;
  height: 37px;
}
::ng-deep .btn-export-section,
::ng-deep #templates {
  display: inline-block;
  vertical-align: top;
}
::ng-deep .btn-export-section {
  padding-left: 15px;
}
::ng-deep ::ng-deep .btn-section {
  text-align: center;
  margin-top: 15px;
}
::ng-deep ::ng-deep.save-btn {
  display: inline-block;
  margin: 0 10px;
}
::ng-deep ::ng-deep.members {
  text-align: center;
}
::ng-deep ::ng-deep#parent-orgs {
  width: auto;
  display: inline-block;
  margin-bottom: 15px;
}
::ng-deep ::ng-deep.groups {
  padding-bottom: 10px;
}
::ng-deep ::ng-deep.groups-content .modal-dialog {
  width: 750px;
}
::ng-deep .column-up .list-group-item {
  width: 48%;
  display: inline-block;
  margin-right: 10px;
  line-height: 20px;
}
::ng-deep .column-up .list-group-item:nth-child(2n) {
  margin-right: 0;
}
::ng-deep .profile-layout th button {
  display: block;
  max-width: 94px;
  width: 100px;
  margin-bottom: 5px;
  font-family: "Open Sans";
  font-weight: 700;
  line-height: 20px;
  font-size: 14px;
  color: #676a6c;
}
::ng-deep table.profile-layout.table-striped input[type=search] {
  min-width: 100px !important;
  width: 100% !important;
  color: #676a6c;
}
::ng-deep table.profile-layout.table-striped input[type=search]::-webkit-search-cancel-button {
  display: none;
}
::ng-deep .inner-form-group {
  margin-bottom: 15px;
  margin-top: 15px;
}
::ng-deep .inner-form-group select {
  margin-top: 10px;
  margin-bottom: 10px;
}
::ng-deep .add-btn-pop {
  margin-right: 10px;
}
::ng-deep .cancel-add-to-org {
  margin-top: 0px !important;
}
::ng-deep .d-inline {
  display: inline-block;
  width: auto;
  clear: none;
}
::ng-deep .tick:before {
  content: "✓";
  color: darkgreen;
}
::ng-deep .cross:before {
  content: "✗";
  color: crimson;
}
::ng-deep .wide-per-page {
  width: 78px !important;
}
::ng-deep legend {
  width: auto;
  border: 0;
  color: #676a6c;
  margin: 0;
  font-size: 16px;
}
::ng-deep fieldset {
  border: 1px solid #ddd;
  padding: 18px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep .form-group.session2 select {
  margin: 0 !important;
  width: 74px;
  height: 35px;
}
::ng-deep .form-group.session1 {
  float: left;
  padding: 0 10px;
  width: 100%;
}
::ng-deep .form-group.session2 {
  float: left;
  padding: 0 10px;
  width: 30%;
}
::ng-deep .add-session {
  margin-top: 15px;
}
::ng-deep .wizard > .steps {
  position: relative;
  display: block;
  width: 100%;
}
::ng-deep .wizard ul,
::ng-deep .tabcontrol ul {
  list-style: none !important;
  padding: 0;
  margin: 0;
  text-align: center;
}
::ng-deep .wizard > .steps > ul > li,
::ng-deep .wizard > .actions > ul > li {
  display: inline-block;
}
::ng-deep .wizard > .steps a,
::ng-deep .wizard > .steps a:hover,
::ng-deep .wizard > .steps a:active {
  display: block;
  width: auto;
  margin: 0 0.5em 0.5em;
  padding: 8px;
  text-decoration: none;
  border-radius: 5px;
}
::ng-deep .wizard > .steps .done a,
::ng-deep .wizard > .steps .done a:hover,
::ng-deep .wizard > .steps .done a:active {
  background: #ccc;
  color: #fff;
}
::ng-deep .wizard > .steps .active a {
  background: #676a6c !important;
}
::ng-deep ::ng-deep.previous-btn {
  background-color: rgb(105, 190, 40) !important;
  color: #fff !important;
}
::ng-deep .inner-form-group input[type=text] {
  display: block;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep .team-table {
  margin-top: 15px;
}

::ng-deep {
  /* HiDPI support */
}
::ng-deep .icheckbox_square-green,
::ng-deep .iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  background: url("https://assets.foursightonline.com/app/images/green.png") no-repeat;
  border: none;
  cursor: pointer;
  margin-left: 0;
}
::ng-deep .profile-layout label {
  vertical-align: middle;
  margin-bottom: 0;
  margin-left: 7px;
}
::ng-deep .profile-layout label.recordpp {
  margin-left: 0;
}
::ng-deep .icheckbox_square-green {
  background-position: 0 0;
}
::ng-deep .icheckbox_square-green.hover {
  background-position: -24px 0;
}
::ng-deep .icheckbox_square-green.checked {
  background-position: -48px 0;
}
::ng-deep .icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}
::ng-deep .icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}
::ng-deep .iradio_square-green {
  background-position: -120px 0;
}
::ng-deep .iradio_square-green.hover {
  background-position: -144px 0;
}
::ng-deep .iradio_square-green.checked {
  background-position: -168px 0;
}
::ng-deep .iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}
::ng-deep .iradio_square-green.checked.disabled {
  background-position: -216px 0;
}
@media (min-resolution: 120dpi) {
  ::ng-deep .icheckbox_square-green,
  ::ng-deep .iradio_square-green {
    background-image: url("https://assets.foursightonline.com/app/images/green@2x.png");
    background-size: 240px 24px;
  }
}

.manage-members-wrapper {
  margin-bottom: 20px;
}
.manage-members-wrapper .manage-inner {
  float: none;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
}
.manage-members-wrapper .manage-inner h2 {
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 30px;
}
.manage-members-wrapper .manage-inner h3 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.manage-members-wrapper .manage-inner .inner-block {
  display: flex;
  display: -ms-flexbox;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
}
@media screen and (max-width: 767px) {
  .manage-members-wrapper .manage-inner .inner-block .col-sm-4,
  .manage-members-wrapper .manage-inner .inner-block .col-sm-6 {
    margin-bottom: 15px;
  }
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box {
  padding: 15px;
  border: 3px solid #aaa;
  height: 100%;
  border-radius: 5px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box i {
  font-size: 60px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul {
  margin-top: 40px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:first-child {
  padding-bottom: 10px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:nth-child(2) {
  font-size: 14px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:nth-child(3) {
  margin-top: 10px;
}
.manage-members-wrapper .manage-inner .bottom-member {
  padding-top: 15px;
  padding-bottom: 15px;
}

.add-mbr-block .inner-single-box {
  position: relative;
  padding-bottom: 35px !important;
}
.add-mbr-block h5 {
  position: absolute;
  left: 0;
  bottom: 4px;
  right: 0;
}

.manage-profile-txt tr td {
  text-align: left;
}
.manage-profile-txt tr td:last-child,
.manage-profile-txt tr th:last-child {
  text-align: center !important;
}

.ibox.ibox-member-dropdown {
  box-shadow: none;
}

.border-green {
  border-color: #86b74b !important;
}

::ng-deep .iradio_square-green {
  float: right;
}

.fname-column,
.lname-column {
  text-transform: capitalize;
}

::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

/****************
  13-December 
****************/
.table-responsive {
  overflow-x: auto;
}
@media only screen and (max-width: 1199px) {
  .table-responsive {
    overflow-x: scroll;
  }
}
.table-responsive table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;
}
.table-responsive table th {
  text-align: left;
}
.table-responsive table th span.sortby {
  top: 5px;
}
.table-responsive table input {
  font: inherit;
}
.table-responsive table input[type=checkbox] {
  margin-left: -20px;
}
.table-responsive .form-group {
  margin-bottom: 15px;
}
.table-responsive label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

span.hide {
  display: none !important;
}

.str-note {
  display: block;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body {
  padding: 20px 30px 30px 30px;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text] {
  width: 100%;
  color: inherit;
  display: block;
  font-size: 14px;
  line-height: 1.4;
  padding: 6px 12px;
  border-radius: 1px;
  background-image: none;
  background-color: #fff;
  border: 1px solid #e5e6e7;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]::-webkit-input-placeholder {
  color: #999;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]:focus, ::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]:focus-visible {
  border-color: #1ab394;
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body.no-pad {
  padding: 0;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  font-size: 12px;
  line-height: 1.5;
  padding: 5px 10px;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}
::ng-deep .modal .hidden {
  display: none;
}

::ng-deep.modal-open {
  overflow: hidden;
}

.dialogbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(236, 236, 236, 0.9);
  z-index: 99999;
}
.dialogbox__wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 30px;
}
.dialogbox__inner {
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.dialogbox__inner[data-width=small] {
  width: min(490px, 100%);
}
.dialogbox__inner[data-width=medium] {
  width: min(600px, 100%);
}
.dialogbox__hdr {
  padding: 15px 30px;
  border-bottom: 1px solid #ddd;
  position: relative;
}
.dialogbox__hdr h2 {
  font-size: 17px;
  line-height: 1.3;
  font-weight: 400;
}
.dialogbox__ftr {
  border-top: 1px solid #ddd;
}
.dialogbox .dialogbox__steps :is(ul, ol):last-child {
  margin-bottom: 0;
}
.dialogbox .dialogbox__steps li {
  font-size: 12px;
}
.dialogbox__smalllabel {
  font-size: 12px;
  font-weight: 400;
}
.dialogbox label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 15px;
  font-weight: 700;
  margin-top: 0;
}
.dialogbox label:last-child {
  margin-bottom: 0;
}
.dialogbox select,
.dialogbox input[type=text] {
  height: 35px;
  padding: 3px 10px;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ddd;
}
.dialogbox select:focus,
.dialogbox input[type=text]:focus {
  outline: none;
}
.dialogbox input[type=radio] {
  margin: 0 5px 0 0;
  position: relative;
  top: 2px;
}
.dialogbox__dpsteps {
  counter-reset: section;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dialogbox__dpsteps-hdr::before {
  counter-increment: section;
  content: counters(section, ".") ". ";
  font-weight: 700;
}
.dialogbox__close {
  --cSize: 16px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
  width: var(--cSize);
  height: var(--cSize);
  padding: 0;
  border: 0;
  background-color: transparent;
  opacity: 0.2;
  transition: 0.3s;
  cursor: pointer;
}
.dialogbox__close:hover {
  opacity: 0.4;
}
.dialogbox__close::before, .dialogbox__close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 2px;
  height: 100%;
  background-color: #000;
  border-radius: 2px;
}
.dialogbox__close::after {
  transform: translate(-50%, -50%) rotate(45deg);
}`, "",{"version":3,"sources":["webpack://./src/app/components/manage-profiles/manage-profiles.component.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgIhB;EACE,eAAA;AD9HF;;ACiIA;EACE,aAAA;EACA,eAAA;AD9HF;;ACiIA;EACE,sBAAA;AD9HF;;ACiIA;EACE,8BAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,aAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;AC4IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADzIJ;AC2II;;;;;;EACE,gBAAA;ADpIN;ACwIE;;EAEE,eA5GO;EA6GP,gBA3GO;AD3BX;ACwII;EALF;;IAMI,eA/GY;EDrBhB;AACF;ACuIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADpBX;ACuII;EALF;;IAMI,eArHY;EDdhB;AACF;ACsIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADbX;ACsII;EALF;;IAMI,eA3HY;EDPhB;AACF;ACqIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADNX;ACsIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADJX;ACuIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADFX;AC2IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADzIJ;AC2II;EACE,gBAAA;ADzIN;AC4II;EAXF;IAYI,eAAA;EDzIJ;AACF;AC4IE;;EAEE,UAAA;EACA,SAAA;AD1IJ;AC6IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AD3IJ;;AC+IA;EACE,sBAxNQ;AD4EV;;AC+IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD5IF;AC8IE;EALF;IAMI,cAAA;ED3IF;AACF;AC6IE;EACE,iBA1Ka;AD+BjB;AC8IE;EACE,gBApLa;EAqLb,WAAA;AD5IJ;;ACiJE;EACE,kBAAA;AD9IJ;ACiJE;EACE,iBAAA;AD/IJ;;ACoJE;EACE,aAAA;ADjJJ;;ACqJA;EACE,kBAAA;ADlJF;ACoJE;EACE,mBAAA;ADlJJ;ACsJI;EACE,sBAAA;ADpJN;ACwJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADwEnB;ACwJI;EACE,sBAAA;ADtJN;ACyJI;EAVF;IAWI,eApOoB;ED8ExB;AACF;ACyJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADvJJ;ACyJI;EACE,sBAAA;ADvJN;AC0JI;EACE,WAAA;ADxJN;AC2JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADmMZ;;AC8JA;EACE,mBA1PO;AD+FT;AC6JE;EAHF;IAII,mBAAA;ED1JF;AACF;AC4JE;EACE,mBAAA;AD1JJ;AC6JE;EACE,aArQK;AD0GT;AC6JI;EAHF;IAII,aAAA;ED1JJ;AACF;AC4JI;EACE,aAAA;AD1JN;;AC+JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD5JF;AC8JE;EACE,eAAA;AD5JJ;AC+JE;EACE,sCAAA;AD7JJ;ACgKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD9JJ;;AC6KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AD1KJ;AC4KI;EACE,kBAAA;AD1KN;AC6KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AD3KN;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,+BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD7KF;AC+KE;EACE,2BAAA;EACA,mBAAA;AD7KJ;ACgLE;EACE,yBAzbiB;EA0bjB,WA1aO;AD4PX;ACiLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD/KJ;ACkLE;EACE,yBAjckB;EAkclB,cArciB;ADqRrB;ACmLE;EACE,yBAvbS;EAwbT,WA1bO;ADyQX;ACmLI;EACE,6BAAA;ADjLN;;ACsLA;EACE;IACE,uBAAA;EDnLF;ECsLA;IACE,yBAAA;EDpLF;AACF;ACuLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,+BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,qBAAA;ADrLF;;ACwLA;EACE,UAAA;ADrLF;ACuLE;EACE,qBAAA;ADrLJ;;ACyLA;EACE,UAAA;ADtLF;;AC0LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADxLJ;AC2LM;EACE,mBAAA;ADzLR;AC8LE;EACE,2BAAA;AD5LJ;AC+LE;EACE,uBAAA;AD7LJ;ACgME;EACE,mBAAA;AD9LJ;;ACmME;EACE,mBAAA;ADhMJ;ACmME;EACE,yBAAA;ADjMJ;ACoME;EACE,sBAAA;ADlMJ;ACqME;EACE,uBAAA;ADnMJ;ACsME;EACE,oBAAA;ADpMJ;;AA9YA;EAEE,6GAAA;EACA,6BAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAgZF;;AA5YA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;AA+YF;;AA5YA;EACE,yBAAA;EACA,kBAAA;AA+YF;;AA5YA;EACE,cAAA;AA+YF;;AA5YA;EACE,0BAAA;EACA,WC0CiB;ADqWnB;;AA5YA;EACE,eAAA;AA+YF;;AA5YA;EACE,6GAAA;AA+YF;;AA3YE;EACE,kBAAA;AA8YJ;AA3YE;EACE,uBAAA;AA6YJ;AA1YE;EACE,WAAA;EACA,mBAAA;AA4YJ;AA1YI;EACE,UAAA;AA4YN;AAtYI;EA+BE,mBChDgB;EDiDhB,8BAAA;EACA,+BAAA;AA0WN;AAzYM;EACE,sBAAA;AA2YR;AAxYM;EACE,sBAAA;AA0YR;AAxYQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AA0YV;AAxYU;EAME,mBAAA;AAqYZ;AA5XM;EACE,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AA8XR;AA5XQ;EACE,uBAAA;AA8XV;AA1XM;EACE,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;AA4XR;AAzXM;EACE,gBC9CW;ADyanB;AAxXM;EACE,WAAA;AA0XR;AAxXQ;EACE,cAAA;AA0XV;AAvXQ;EACE,mBAAA;EACA,oBAAA;AAyXV;AAvXU;EACE,yBAAA;AAyXZ;AAlXQ;EACE,mBCnEK;EDoEL,WCtES;EDuET,2BAAA;EACA,mBAAA;AAoXV;AA7WM;EACE,uBAAA;AA+WR;AAxWI;EACE,iCAAA;EACA,2BAAA;EACA,iBAAA;AA0WN;AAxWM;EACE,mBC3FO;ADqcf;AArWE;;EAEE,wBAAA;AAuWJ;AApWE;EACE,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAsWJ;AAnWE;EACE,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAqWJ;AAlWE;EACE,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAoWJ;AAjWE;EACE,WAAA;AAmWJ;AAjWI;EACE,mBC/JgB;ADkgBtB;AAhWI;;EAEE,iBAAA;AAkWN;AA/VI;;EAEE,kBAAA;AAiWN;AA1VI;EACE,kBAAA;AA4VN;AA1VM;EACE,sBAAA;AA4VR;AAzVM;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WC1KW;ED2KX,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,2CAAA;AA2VR;AAtVQ;EACE,cAAA;AAwVV;AAlVE;EACE,WAAA;EACA,YAAA;AAoVJ;AAjVE;;EAEE,qBAAA;EACA,mBAAA;AAmVJ;AAhVE;EACE,kBAAA;AAkVJ;AA/UE;EACE,kBAAA;EACA,gBAAA;AAiVJ;AA1UE;EACE,qBAAA;EACA,cAAA;AA4UJ;AAzUE;EACE,kBAAA;AA2UJ;AAxUE;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;AA0UJ;AAvUE;EACE,oBAAA;AAyUJ;AAtUE;EACE,YAAA;AAwUJ;AApUI;EACE,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AAsUN;AAnUI;EACE,eAAA;AAqUN;AAjUE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAmUJ;AAhUE;EACE,2BAAA;EACA,sBAAA;EACA,cAAA;AAkUJ;AAhUI;EACE,aAAA;AAkUN;AA9TE;EACE,mBAAA;EACA,gBAAA;AAgUJ;AA9TI;EACE,gBAAA;EACA,mBAAA;AAgUN;AA5TE;EACE,kBAAA;AA8TJ;AA3TE;EACE,0BAAA;AA6TJ;AA1TE;EACE,qBAAA;EACA,WAAA;EACA,WAAA;AA4TJ;AAzTE;EACE,YAAA;EACA,gBAAA;AA2TJ;AAxTE;EACE,YAAA;EACA,cAAA;AA0TJ;AAvTE;EACE,sBAAA;AAyTJ;AAtTE;EACE,WAAA;EACA,SAAA;EACA,cCzViB;ED0VjB,SAAA;EACA,eAAA;AAwTJ;AArTE;EACE,sBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AAuTJ;AApTE;EACE,oBAAA;EACA,WAAA;EACA,YAAA;AAsTJ;AAnTE;EACE,WAAA;EACA,eAAA;EACA,WAAA;AAqTJ;AAlTE;EACE,WAAA;EACA,eAAA;EACA,UAAA;AAoTJ;AAjTE;EACE,gBAAA;AAmTJ;AAhTE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;AAkTJ;AA/SE;;EAEE,2BAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AAiTJ;AA9SE;;EAEE,qBAAA;AAgTJ;AA7SE;;;EAGE,cAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EAGA,kBAAA;AA+SJ;AA5SE;;;EAGE,gBCvZgB;EDwZhB,WC3Xe;ADyqBnB;AA3SE;EACE,8BAAA;AA6SJ;AA1SE;EAEE,8CAAA;EACA,sBAAA;AA2SJ;AAxSE;EACE,cAAA;EACA,WAAA;EACA,mBAAA;AA0SJ;AAvSE;EACE,gBAAA;AAySJ;;AArSA;EAqEE,kBAAA;AAoOF;AAvSE;;EAEE,qBAAA;GAySF,eAxSE;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oFAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAySJ;AAtSE;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;AAwSJ;AAtSI;EACE,cAAA;AAwSN;AApSE;EACE,wBAAA;AAsSJ;AAnSE;EACE,4BAAA;AAqSJ;AAlSE;EACE,4BAAA;AAoSJ;AAjSE;EACE,4BAAA;EACA,eAAA;AAmSJ;AAhSE;EACE,4BAAA;AAkSJ;AA/RE;EACE,6BAAA;AAiSJ;AA9RE;EACE,6BAAA;AAgSJ;AA7RE;EACE,6BAAA;AA+RJ;AA5RE;EACE,6BAAA;EACA,eAAA;AA8RJ;AA3RE;EACE,6BAAA;AA6RJ;AAzRE;EAIE;;IAEE,mFAAA;IAEA,2BAAA;EAwRJ;AACF;;AAnRA;EACE,mBAAA;AAsRF;AApRE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAsRJ;AApRI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAsRN;AAnRI;EACE,iBAAA;EACA,oBAAA;AAqRN;AAlRI;EACE,aAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;AAoRN;AAlRM;EAEE;;IAEE,mBAAA;EAmRR;AACF;AAhRM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAkRR;AAhRQ;EACE,eAAA;AAkRV;AA/QQ;EACE,gBAAA;AAiRV;AA/QU;EACE,oBAAA;AAiRZ;AA9QU;EACE,eAAA;AAgRZ;AA7QU;EACE,gBAAA;AA+QZ;AAzQI;EACE,iBAAA;EACA,oBAAA;AA2QN;;AApQE;EACE,kBAAA;EACA,+BAAA;AAuQJ;AApQE;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;AAsQJ;;AA9PI;EACE,gBAAA;AAiQN;AA9PI;;EAEE,6BAAA;AAgQN;;AA3PA;EACE,gBAAA;AA8PF;;AA3PA;EACE,gCAAA;AA8PF;;AA3PA;EACE,YAAA;AA8PF;;AA3PA;;EAEE,0BAAA;AA8PF;;AA3PA;EACE,oCAAA;AA8PF;;AA3PA;;gBAAA;AAMA;EACE,gBAAA;AA2PF;AAzPE;EAHF;IAII,kBAAA;EA4PF;AACF;AA1PE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;AA4PJ;AA1PI;EACE,gBAAA;AA4PN;AA1PM;EACE,QAAA;AA4PR;AAxPI;EACE,aAAA;AA0PN;AAxPM;EACE,kBAAA;AA0PR;AArPE;EACE,mBAAA;AAuPJ;AApPE;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAsPJ;;AA9OI;EACE,yBAAA;AAiPN;;AA5OA;EACE,wBAAA;AA+OF;;AA5OA;EACE,cAAA;AA+OF;;AA3OA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AA8OF;AA5OE;EACE,yBAAA;AA8OJ;AA3OE;EACE,oCAAA;AA6OJ;AAzOI;EACE,mCAAA;AA2ON;AAxOI;EACE,UAAA;AA0ON;AArOI;EACE,0BAAA;AAuON;AAnOE;EACE,kBAAA;EACA,gBAAA;AAqOJ;AAlOE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAoOJ;AAlOI;EALF;IAMI,YAAA;IACA,iBAAA;EAqOJ;AACF;AAnOI;EACE,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AAqON;AAnOM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAqOR;AAnOQ;EACE,aAAA;AAqOV;AAjOM;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AAmOR;AAhOM;EACE,4BAAA;EACA,kBAAA;AAkOR;AA/NU;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAiOZ;AA9NU;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8EAAA;AAgOZ;AA9NY;EACE,WAAA;AAgOd;AA7NY;EAEE,qBAAA;EACA,aAAA;AA8Nd;AAzNQ;EACE,UAAA;AA2NV;AArNE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AAuNJ;AArNI;EACE,qBAAA;EACA,yBAAA;AAuNN;AApNI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAsNN;AApNM;EACE,qBAAA;EACA,yBAAA;AAsNR;AAlNI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AAoNN;AAlNM;EACE,qBAAA;EACA,yBAAA;AAoNR;AAhNI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAkNN;AAhNM;EACE,qBAAA;EACA,yBAAA;AAkNR;AA7ME;EACE,aAAA;AA+MJ;;AA3MA;EACE,gBAAA;AA8MF;;AAzMA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;AA4MF;AA1ME;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AA4MN;AAzME;EACI,kBAAA;EACA,wCAAA;AA2MN;AAzMM;EACI,uBAAA;AA2MV;AAxMM;EACI,uBAAA;AA0MV;AAtME;EACI,kBAAA;EACA,6BAAA;EACA,kBAAA;AAwMN;AAtMM;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAwMV;AApME;EACI,0BAAA;AAsMN;AAjMM;EACI,gBAAA;AAmMV;AAhMM;EACI,eAAA;AAkMV;AA9LE;EACI,eAAA;EACA,gBAAA;AAgMN;AA7LE;EACI,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AA+LN;AA7LM;EACI,gBAAA;AA+LV;AA3LE;;EAEI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;AA6LN;AA3LM;;EACI,aAAA;AA8LV;AA1LE;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;AA4LN;AAzLE;EAEI,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;AA0LN;AAtLU;EACI,0BAAA;EACA,oCAAA;EACA,gBAAA;AAwLd;AAnLE;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAqLN;AAnLM;EACI,YAAA;AAqLV;AAlLM;EAEI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAmLV;AAhLM;EACI,8CAAA;AAkLV","sourcesContent":["@import './../../../assets/styles/variables';\n\n::ng-deep.profile_types {\n  //background-image: url($assets+\"/images/foursight-profile-types.png\") !important;\n  background-image: url($assets+\"/images/foursight-profile-types.svg\") !important;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  width: 34px;\n  height: 15px;\n  margin-left: 6px;\n  //background-size: 175px 46px;\n}\n\n::ng-deep #holder>li {\n  padding: 5px;\n  margin: 2px;\n  display: inline-block;\n}\n\n::ng-deep #holder>li[data-page] {\n  border: solid #a0a0a0 1px;\n  border-radius: 5px;\n}\n\n::ng-deep #holder>li.separator:before {\n  content: '...';\n}\n\n::ng-deep #holder>li.active {\n  background-color: darkblue;\n  color: $color-light-type;\n}\n\n::ng-deep #holder>li[data-page]:hover {\n  cursor: pointer;\n}\n\n::ng-deep .no-profile {\n  background-image: url($assets+\"/images/foursight-profile-types.svg\") !important;\n}\n\n::ng-deep {\n  .checkbox {\n    padding-left: 20px;\n  }\n\n  .pull-right {\n    float: right !important;\n  }\n\n  .ibox-title.profile-heading-2 h5 {\n    width: 100%;\n    vertical-align: top;\n\n    ul.inline-list {\n      padding: 0;\n    }\n  }\n\n  table.profile-layout.table-striped {\n\n    tr {\n\n      td {\n        vertical-align: middle;\n      }\n\n      th {\n        vertical-align: middle;\n\n        span.sortby {\n          width: 100%;\n          height: 100%;\n          text-align: right;\n          display: block;\n          position: absolute;\n          right: 0;\n          top: 14px;\n          cursor: pointer;\n          font-size: 16px;\n\n          &.fname-asc,\n          &.lname-asc,\n          &.email-asc,\n          &.org-asc,\n          &.team-asc,\n          &.profile-asc {\n            top: 8px !important;\n          }\n        }\n      }\n\n      background: $color-neutral-light;\n      border-left: 1px solid #d0d0d0;\n      border-right: 1px solid #d0d0d0;\n\n      input {\n        border: 1px solid $color-neutral-mid;\n        padding: 6px 10px;\n        height: 34px;\n        line-height: 1;\n\n        &[type=\"checkbox\"] {\n          height: auto !important;\n        }\n      }\n\n      select {\n        border: 1px solid $color-neutral-mid;\n        padding: 6px 12px;\n        height: 34px;\n        min-width: 100px;\n        font-family: 'Open Sans';\n        font-weight: 700;\n        font-size: 14px;\n      }\n\n      &:nth-child(odd) {\n        background: $color-light-type;\n      }\n\n      a {\n        color: #333;\n\n        &:hover {\n          color: #337ab7;\n        }\n\n        &.label.label-default {\n          background: #d1dade;\n          border-radius: 2.5px;\n\n          &:hover {\n            background-color: #5e5e5e;\n          }\n        }\n      }\n\n      &:first-child {\n\n        th {\n          background: $fs-dark-grey;\n          color: $color-light-type;\n          padding: 10px 10px 5px 10px;\n          white-space: nowrap;\n        }\n      }\n    }\n\n    tfoot {\n\n      tr {\n        border: none !important;\n      }\n    }\n  }\n\n  ::ng-deep #holder {\n\n    li {\n      border: 1px solid $color-neutral-mid !important;\n      border-radius: 0 !important;\n      padding: 7px 11px;\n\n      &.active {\n        background: $fs-dark-grey;\n      }\n    }\n  }\n\n  table.profile-layout.table-striped tr input[type=\"date\"]::-webkit-inner-spin-button,\n  table.profile-layout.table-striped tr input[type=\"date\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n  }\n\n  span.invitation-text {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 160px !important;\n    overflow: hidden;\n    display: block;\n  }\n\n  span.contact-lists {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100px !important;\n    overflow: hidden;\n    display: block;\n  }\n\n  a.orgs-lists {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 80px !important;\n    overflow: hidden;\n    display: block;\n  }\n\n  .selectDataChild {\n    width: 100%;\n\n    tr:nth-child(odd) {\n      background: $color-neutral-light;\n    }\n\n    th,\n    td {\n      padding: 5px 10px;\n    }\n\n    th:last-child,\n    td:last-child {\n      text-align: center;\n    }\n\n  }\n\n  .reset-input {\n\n    th {\n      position: relative;\n\n      input[type=\"search\"] {\n        width: 100% !important;\n      }\n\n      .reset-close {\n        display: none;\n        position: absolute;\n        top: 0;\n        right: 25px;\n        bottom: 0;\n        margin: auto;\n        border-radius: 50%;\n        background: #ddd;\n        border: none !important;\n        text-align: center;\n        font-size: 14px;\n        padding: 0px !important;\n        height: 16px !important;\n        width: 16px !important;\n        color: $color-light-type;\n        line-height: 1.2 !important;\n        font-family: Arial !important;\n        transform: rotate(45deg) !important;\n        -webkit-transform: rotate(45deg) !important;\n      }\n\n      &:hover {\n\n        .reset-close {\n          display: block;\n        }\n      }\n    }\n  }\n\n  #templates {\n    width: auto;\n    height: 37px;\n  }\n\n  .btn-export-section,\n  #templates {\n    display: inline-block;\n    vertical-align: top;\n  }\n\n  .btn-export-section {\n    padding-left: 15px;\n  }\n\n  ::ng-deep .btn-section {\n    text-align: center;\n    margin-top: 15px;\n\n    // button{\n    //   margin: 0 20px;\n    // }\n  }\n\n  ::ng-deep.save-btn {\n    display: inline-block;\n    margin: 0 10px;\n  }\n\n  ::ng-deep.members {\n    text-align: center;\n  }\n\n  ::ng-deep#parent-orgs {\n    width: auto;\n    display: inline-block;\n    margin-bottom: 15px;\n  }\n\n  ::ng-deep.groups {\n    padding-bottom: 10px;\n  }\n\n  ::ng-deep.groups-content .modal-dialog {\n    width: 750px;\n  }\n\n  .column-up {\n    .list-group-item {\n      width: 48%;\n      display: inline-block;\n      margin-right: 10px;\n      line-height: 20px;\n    }\n\n    .list-group-item:nth-child(2n) {\n      margin-right: 0;\n    }\n  }\n\n  .profile-layout th button {\n    display: block;\n    max-width: 94px;\n    width: 100px;\n    margin-bottom: 5px;\n    font-family: 'Open Sans';\n    font-weight: 700;\n    line-height: 20px;\n    font-size: 14px;\n    color: #676a6c;\n  }\n\n  table.profile-layout.table-striped input[type=\"search\"] {\n    min-width: 100px !important;\n    width: 100% !important;\n    color: #676a6c;\n\n    &::-webkit-search-cancel-button {\n      display: none;\n    }\n  }\n\n  .inner-form-group {\n    margin-bottom: 15px;\n    margin-top: 15px;\n\n    select {\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n  }\n\n  .add-btn-pop {\n    margin-right: 10px;\n  }\n\n  .cancel-add-to-org {\n    margin-top: 0px !important;\n  }\n\n  .d-inline {\n    display: inline-block;\n    width: auto;\n    clear: none;\n  }\n\n  .tick:before {\n    content: \"\\2713\";\n    color: darkgreen;\n  }\n\n  .cross:before {\n    content: \"\\2717\";\n    color: crimson;\n  }\n\n  .wide-per-page {\n    width: 78px !important;\n  }\n\n  legend {\n    width: auto;\n    border: 0;\n    color: $body-content-color;\n    margin: 0;\n    font-size: 16px;\n  }\n\n  fieldset {\n    border: 1px solid #ddd;\n    padding: 18px;\n    width: 100%;\n    margin-bottom: 15px;\n  }\n\n  .form-group.session2 select {\n    margin: 0 !important;\n    width: 74px;\n    height: 35px;\n  }\n\n  .form-group.session1 {\n    float: left;\n    padding: 0 10px;\n    width: 100%;\n  }\n\n  .form-group.session2 {\n    float: left;\n    padding: 0 10px;\n    width: 30%;\n  }\n\n  .add-session {\n    margin-top: 15px;\n  }\n\n  .wizard>.steps {\n    position: relative;\n    display: block;\n    width: 100%;\n  }\n\n  .wizard ul,\n  .tabcontrol ul {\n    list-style: none !important;\n    padding: 0;\n    margin: 0;\n    text-align: center;\n  }\n\n  .wizard>.steps>ul>li,\n  .wizard>.actions>ul>li {\n    display: inline-block;\n  }\n\n  .wizard>.steps a,\n  .wizard>.steps a:hover,\n  .wizard>.steps a:active {\n    display: block;\n    width: auto;\n    margin: 0 0.5em 0.5em;\n    padding: 8px;\n    text-decoration: none;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    border-radius: 5px;\n  }\n\n  .wizard>.steps .done a,\n  .wizard>.steps .done a:hover,\n  .wizard>.steps .done a:active {\n    background: $color-neutral-mid;\n    color: $color-light-type;\n  }\n\n  .wizard>.steps .active a {\n    background: $body-content-color !important;\n  }\n\n  ::ng-deep.previous-btn {\n    // margin-right: 10px;\n    background-color: $develop-color !important;\n    color: $color-light-type !important;\n  }\n\n  .inner-form-group input[type=\"text\"] {\n    display: block;\n    width: 100%;\n    margin-bottom: 15px;\n  }\n\n  .team-table {\n    margin-top: 15px;\n  }\n}\n\n::ng-deep {\n\n  .icheckbox_square-green,\n  .iradio_square-green {\n    display: inline-block;\n    *display: inline;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n    width: 22px;\n    height: 22px;\n    background: url($assets+'/images/green.png') no-repeat;\n    border: none;\n    cursor: pointer;\n    margin-left: 0;\n  }\n\n  .profile-layout label {\n    vertical-align: middle;\n    margin-bottom: 0;\n    margin-left: 7px;\n\n    &.recordpp {\n      margin-left: 0;\n    }\n  }\n\n  .icheckbox_square-green {\n    background-position: 0 0;\n  }\n\n  .icheckbox_square-green.hover {\n    background-position: -24px 0;\n  }\n\n  .icheckbox_square-green.checked {\n    background-position: -48px 0;\n  }\n\n  .icheckbox_square-green.disabled {\n    background-position: -72px 0;\n    cursor: default;\n  }\n\n  .icheckbox_square-green.checked.disabled {\n    background-position: -96px 0;\n  }\n\n  .iradio_square-green {\n    background-position: -120px 0;\n  }\n\n  .iradio_square-green.hover {\n    background-position: -144px 0;\n  }\n\n  .iradio_square-green.checked {\n    background-position: -168px 0;\n  }\n\n  .iradio_square-green.disabled {\n    background-position: -192px 0;\n    cursor: default;\n  }\n\n  .iradio_square-green.checked.disabled {\n    background-position: -216px 0;\n  }\n\n  /* HiDPI support */\n  @media (-o-min-device-pixel-ratio: 5/4),\n  (-webkit-min-device-pixel-ratio: 1.25),\n  (min-resolution: 120dpi) {\n\n    .icheckbox_square-green,\n    .iradio_square-green {\n      background-image: url($assets+'/images/green@2x.png');\n      -webkit-background-size: 240px 24px;\n      background-size: 240px 24px;\n    }\n  }\n}\n\n\n.manage-members-wrapper {\n  margin-bottom: 20px;\n\n  .manage-inner {\n    float: none;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 15px;\n\n    h2 {\n      font-weight: 600;\n      margin-top: 0;\n      margin-bottom: 30px;\n    }\n\n    h3 {\n      padding-top: 10px;\n      padding-bottom: 10px;\n    }\n\n    .inner-block {\n      display: flex;\n      display: -ms-flexbox;\n      flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n\n      @media screen and (max-width: 767px) {\n\n        .col-sm-4,\n        .col-sm-6 {\n          margin-bottom: 15px;\n        }\n      }\n\n      .inner-single-box {\n        padding: 15px;\n        border: 3px solid $border-color;\n        height: 100%;\n        border-radius: 5px;\n\n        i {\n          font-size: 60px;\n        }\n\n        ul {\n          margin-top: 40px;\n\n          li:first-child {\n            padding-bottom: 10px;\n          }\n\n          li:nth-child(2) {\n            font-size: 14px;\n          }\n\n          li:nth-child(3) {\n            margin-top: 10px;\n          }\n        }\n      }\n    }\n\n    .bottom-member {\n      padding-top: 15px;\n      padding-bottom: 15px;\n    }\n  }\n}\n\n.add-mbr-block {\n\n  .inner-single-box {\n    position: relative;\n    padding-bottom: 35px !important;\n  }\n\n  h5 {\n    position: absolute;\n    left: 0;\n    bottom: 4px;\n    right: 0;\n  }\n}\n\n.manage-profile-txt {\n\n  tr {\n\n    td {\n      text-align: left;\n    }\n\n    td:last-child,\n    th:last-child {\n      text-align: center !important;\n    }\n  }\n}\n\n.ibox.ibox-member-dropdown {\n  box-shadow: none;\n}\n\n.border-green {\n  border-color: #86b74b !important;\n}\n\n::ng-deep .iradio_square-green {\n  float: right;\n}\n\n.fname-column,\n.lname-column {\n  text-transform: capitalize;\n}\n\n::ng-deep.grey {\n  background: rgba(236, 236, 236, 0.9);\n}\n\n/****************\n  13-December \n****************/\n\n// Table Styling\n\n.table-responsive {\n  overflow-x: auto;\n\n  @media #{$pc} {\n    overflow-x: scroll;\n  }\n\n  table {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n    background-color: transparent;\n    border-collapse: collapse;\n    border-spacing: 0;\n\n    th {\n      text-align: left;\n\n      span.sortby {\n        top: 5px;\n      }\n    }\n\n    input {\n      font: inherit;\n\n      &[type=checkbox] {\n        margin-left: -20px;\n      }\n    }\n  }\n\n  .form-group {\n    margin-bottom: 15px;\n  }\n\n  label {\n    display: inline-block;\n    max-width: 100%;\n    margin-bottom: 5px;\n    font-weight: 700;\n  }\n}\n\n.table-striped {\n\n  &>tbody {\n\n    &>tr:nth-of-type(odd) {\n      background-color: #f9f9f9;\n    }\n  }\n}\n\nspan.hide {\n  display: none !important;\n}\n\n.str-note {\n  display: block;\n}\n\n// Modal Design\n::ng-deep .modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n\n  &.show {\n    display: block !important;\n  }\n\n  &.grey {\n    background: rgba(236, 236, 236, 0.9);\n  }\n\n  &.fade {\n    .modal-dialog {\n      transition: transform 0.3s ease-out;\n    }\n\n    &.in {\n      opacity: 1;\n    }\n  }\n\n  &.in {\n    .modal-dialog {\n      transform: translate(0, 0);\n    }\n  }\n\n  &.modal-open {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px;\n\n    @media (min-width: 768px) {\n      width: 600px;\n      margin: 30px auto;\n    }\n\n    .modal-content {\n      background-clip: padding-box;\n      background-color: #FFFFFF;\n      border: 1px solid rgba(0, 0, 0, 0);\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n      outline: 0 none;\n      position: relative;\n\n      .close {\n        float: right;\n        font-size: 21px;\n        font-weight: bold;\n        line-height: 1;\n        color: #000;\n        text-shadow: 0 1px 0 #fff;\n        filter: alpha(opacity=20);\n        opacity: 0.2;\n\n        &:focus-visible {\n          outline: none;\n        }\n      }\n\n      button.close {\n        padding: 0;\n        cursor: pointer;\n        background: transparent;\n        border: 0;\n        -webkit-appearance: none;\n        appearance: none;\n      }\n\n      .modal-body {\n        padding: 20px 30px 30px 30px;\n        position: relative;\n\n        form {\n          label {\n            display: inline-block;\n            max-width: 100%;\n            margin-bottom: 5px;\n            font-weight: 700;\n          }\n\n          input[type=text] {\n            width: 100%;\n            color: inherit;\n            display: block;\n            font-size: 14px;\n            line-height: 1.4;\n            padding: 6px 12px;\n            border-radius: 1px;\n            background-image: none;\n            background-color: #fff;\n            border: 1px solid #e5e6e7;\n            transition: border-color .15s ease-in-out 0s, box-shadow .15s ease-in-out 0s;\n\n            &::-webkit-input-placeholder {\n              color: #999;\n            }\n\n            &:focus,\n            &:focus-visible {\n              border-color: #1ab394;\n              outline: none;\n            }\n          }\n        }\n\n        &.no-pad {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 14px;\n    border-color: #73BF38;\n    background-color: #73BF38;\n\n    &:hover {\n      border-color: #4cae4c;\n      background-color: #4cae4c;\n    }\n\n    &--dngr {\n      color: #fff;\n      border-color: #ED5565;\n      background-color: #ED5565;\n\n      &:hover {\n        border-color: #ec4758;\n        background-color: #ec4758;\n      }\n    }\n\n    &--info {\n      color: #fff;\n      font-size: 12px;\n      line-height: 1.5;\n      padding: 5px 10px;\n      border-color: #23c6c8;\n      background-color: #23c6c8;\n\n      &:hover {\n        border-color: #21b9bb;\n        background-color: #21b9bb;\n      }\n    }\n\n    &--wrng {\n      color: #fff;\n      border-color: #f8ac59;\n      background-color: #f8ac59;\n\n      &:hover {\n        border-color: #f7a54a;\n        background-color: #f7a54a;\n      }\n    }\n  }\n\n  .hidden {\n    display: none;\n  }\n}\n\n::ng-deep.modal-open {\n  overflow: hidden;\n}\n\n\n\n.dialogbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgb(236 236 236 / 90%);\n  z-index: 99999;\n\n  &__wrapper {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      width: 100%;\n      height: 100%;\n      overflow-y: auto;\n      padding: 30px;\n  }\n\n  &__inner {\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n\n      &[data-width=\"small\"] {\n          width: min(490px, 100%);\n      }\n\n      &[data-width=\"medium\"] {\n          width: min(600px, 100%);\n      }\n  }\n\n  &__hdr {\n      padding: 15px 30px;\n      border-bottom: 1px solid $clrDarkGray1;\n      position: relative;\n\n      h2 {\n          font-size: 17px;\n          line-height: 1.3;\n          font-weight: 400;\n      }\n  }\n\n  &__ftr {\n      border-top: 1px solid $clrDarkGray1;\n  }\n\n  .dialogbox__steps {\n\n      :is(ul, ol):last-child {\n          margin-bottom: 0;\n      }\n\n      li {\n          font-size: 12px;\n      }\n  }\n\n  &__smalllabel {\n      font-size: 12px;\n      font-weight: 400;\n  }\n\n  label {\n      display: inline-block;\n      max-width: 100%;\n      margin-bottom: 15px;\n      font-weight: 700;\n      margin-top: 0;\n\n      &:last-child {\n          margin-bottom: 0;\n      }\n  }\n\n  select,\n  input[type=\"text\"] {\n      height: 35px;\n      padding: 3px 10px;\n      width: 100%;\n      background-color: #fff;\n      border: 1px solid $clrDarkGray1;\n\n      &:focus {\n          outline: none;\n      }\n  }\n\n  input[type=\"radio\"] {\n      margin: 0 5px 0 0;\n      position: relative;\n      top: 2px;\n  }\n\n  &__dpsteps {\n\n      counter-reset: section;\n      list-style-type: none;\n      padding: 0;\n      margin: 0;\n\n      &-hdr {\n\n          &::before {\n              counter-increment: section;\n              content: counters(section, \".\") \". \";\n              font-weight: 700;\n          }\n      }\n  }\n\n  &__close {\n      --cSize: 16px;\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 15px;\n      width: var(--cSize);\n      height: var(--cSize);\n      padding: 0;\n      border: 0;\n      background-color: transparent;\n      opacity: 0.2;\n      transition: 0.3s;\n      cursor: pointer;\n\n      &:hover {\n          opacity: 0.4;\n      }\n\n      &::before,\n      &::after {\n          content: \"\";\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%) rotate(-45deg);\n          width: 2px;\n          height: 100%;\n          background-color: #000;\n          border-radius: 2px;\n      }\n\n      &::after {\n          transform: translate(-50%, -50%) rotate(45deg);\n      }\n  }\n}","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
